export * from './departments.service';
import { DepartmentsService } from './departments.service';
export * from './executableVersion.service';
import { ExecutableVersionService } from './executableVersion.service';
export * from './holidays.service';
import { HolidaysService } from './holidays.service';
export * from './internalDepartment.service';
import { InternalDepartmentService } from './internalDepartment.service';
export * from './internalLocation.service';
import { InternalLocationService } from './internalLocation.service';
export * from './internalWorkschedules.service';
import { InternalWorkschedulesService } from './internalWorkschedules.service';
export * from './locations.service';
import { LocationsService } from './locations.service';
export * from './workSchedules.service';
import { WorkSchedulesService } from './workSchedules.service';
export const APIS = [DepartmentsService, ExecutableVersionService, HolidaysService, InternalDepartmentService, InternalLocationService, InternalWorkschedulesService, LocationsService, WorkSchedulesService];
